
































































































































































































































































































































































































import { Component, Vue, Emit, Watch, Ref } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeAutorizacaoStore from '@/components/Backoffice/Store/BackofficeAutorizacaoStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import SolicitacaoComentariosStore from '@/components/SolicitacaoComentarios/Store/SolicitacaoComentariosStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import HistoricoSolicitacaoStore from '@/components/HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import { Autorizacao, PendenciaSolicitacao } from '@/types/core'
import { timeoutDefault, groupCollectionByField, maskHour, timeout } from '@/utils/common'
import { TipoMensagemEnum, PendenciaMensagem, TipoDocumentoUpload, CancelarSolicitacaoParam, TipoOrigemEnum, SolicitacaoAcoesBackofficeEnum, SituacaoEnum } from '@/types/_'
import moment from 'moment'

/* EventBus */
import EventBus from '@/plugins/EventBus'

@Component

export default class ComponentModalAutorizada extends Vue {
  $refs!: {
    autorizacaoForm: any,
  }

  tipoAutorizacaoAnexo: any = {
    pedidoMedico: true,
    laudo: true,
    cotacaoOpme: true,
    laudoAnestesista: true,
    anexoOperadora: true,
    resumo: true,
  }

  autorizacao: Autorizacao.IAutorizacao = new Autorizacao.Autorizacao()

  get showModalAutorizada() {
    const show = this.getBackofficeGlobalStore.modal.autorizada
    this.toggleHtmlOverflow(show)
    this.scrollToMensagem()
    return show
  }

  set showModalAutorizada(value) {
    this.getBackofficeGlobalStore.setModal({ name: 'autorizada', value })
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeAutorizacaoStore() {
    return getModule(BackofficeAutorizacaoStore, this.$store)
  }

  get loadingClose() {
    return this.loadClose
  }

  set loadingClose(value: boolean) {
    this.loadClose = value
  }

  /**
   * Pendência
   */

  loadClose: boolean = false
  loadComentarios: boolean = false
  loadHistorico: boolean = false
  modalConfirmarPendencia: boolean = false
  modalPendencia: boolean = false
  loadPendencia: boolean = false
  loadConfirmar: boolean = false
  loadClosePedencia: boolean = false
  loadCloseConfirmarPendencia: boolean = false
  loadUpload: boolean = false
  loadConfirmarPendencia: boolean = false
  loadCancelamento: boolean = false
  loadMensagem: boolean = false
  mensagem: string = ''

  inputFiles: any[] = []

  pendenciaSolicitacao: PendenciaSolicitacao.IPendenciaSolicitacao = new PendenciaSolicitacao.PendenciaSolicitacao()

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(value: boolean) {
    this.loadConfirmar = value
  }

  get loadingPendencia() {
    return this.loadPendencia
  }

  set loadingPendencia(value: boolean) {
    this.loadPendencia = value
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: boolean) {
    this.loadHistorico = value
  }

  get loadingComentarios() {
    return this.loadComentarios
  }

  set loadingComentarios(value: boolean) {
    this.loadComentarios = value
  }

  get loadingMensagem() {
    return this.loadMensagem
  }

  set loadingMensagem(val: boolean) {
    this.loadMensagem = val
  }

  get loadingUpload() {
    return this.loadUpload
  }

  set loadingUpload(val: boolean) {
    this.loadUpload = val
  }

  get getMensagem() {
    return this.mensagem
  }

  set getMensagem(texto: string) {
    this.mensagem = texto
  }

  get getPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getComentariosStore() {
    return getModule(SolicitacaoComentariosStore, this.$store)
  }

  get getHistoricoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get showModalPendencia() {
    return this.modalPendencia
  }

  set showModalPendencia(value: boolean) {
    this.modalPendencia = value
  }

  get showModalConfirmarPendencia() {
    return this.modalConfirmarPendencia
  }

  set showModalConfirmarPendencia(value: boolean) {
    this.modalConfirmarPendencia = value
  }

  get loadingClosePendencia() {
    return this.loadClosePedencia
  }

  set loadingClosePendencia(value: boolean) {
    this.loadClosePedencia = value
  }

  get loadingCloseConfirmarPendencia() {
    return this.loadCloseConfirmarPendencia
  }

  set loadingCloseConfirmarPendencia(val: boolean) {
    this.loadCloseConfirmarPendencia = val
  }

  get getDisplayPendencia() {
    return { nomePaciente: this.getBackofficeGlobalStore.solicitacao.pacienteNome,
      nomeMedico: this.getBackofficeGlobalStore.solicitacao.medicoSolicitante.nome }
  }

  get getMensagens() {
    return this.getPendenciaStore.pendencia.mensagens
  }

  get getTipoMensagemEnum() {
    return TipoMensagemEnum
  }

  get loadingConfirmarPendencia() {
    return this.loadConfirmarPendencia
  }

  set loadingConfirmarPendencia(val: boolean) {
    this.loadConfirmarPendencia = val
  }

  get loadingCancelamento() {
    return this.loadCancelamento
  }

  set loadingCancelamento(value: boolean) {
    this.loadCancelamento = value
  }

  async confirmar() {
    this.loadingConfirmar = true
    await timeoutDefault()

    const {
      protocoloOPME,
      protocoloOperadora,
      autorizacaoValidade,
      autorizacaoObservacao,
      operadoraSenha,
      operadoraQuantidadeDiasAutorizado,
      operadoraSenhaProvisoria,
    } = this.getBackofficeGlobalStore.solicitacao

    const body: any = {
      protocoloOPME,
      protocoloOperadora,
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      statusAutorizacao: this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora,
      autorizacaoValidade,
      autorizacaoObservacao,
      operadoraSenha,
      operadoraQuantidadeDiasAutorizado,
      operadoraSenhaProvisoria,
      motivoCancelamentoDaSolicitacaoId: this.getSolicitacaoCancelamentoStore.motivo,
    }

    Object.entries(body).forEach(([key, value]) => {
      // @ts-ignore
      if (['', null, 0, undefined].includes(value)) {
        delete body[key]
      }
    })

    if (this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora === SituacaoEnum.EmAnalise) {
      if (this.$refs.autorizacaoForm.$refs.autorizacaoForm.validate()) {
        const response = await this.autorizacao.enviarGuias({ acao: SolicitacaoAcoesBackofficeEnum.AutorizacaoAutorizar, body })

        if (response.success) {
          EventBus.$emit('setSnackbar', { show: true, text: 'Autorização em análise.', icon: 'done', color: '#2E7D32' })
          await this.closeModal()
        } else {
          EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao atualizar a autorização.', icon: 'warning', color: '#C62828' })
        }
      }

      this.loadingConfirmar = false
      return false
      // if (this.$refs.autorizacaoForm.$refs.autorizacaoForm.validate()) {
      //   const params: any = {
      //     acao: SolicitacaoAcoesBackofficeEnum.AutorizacaoEmAnalise,
      //     body: {
      //       solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      //       statusAutorizacao: this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora,
      //     },
      //   }

      //   if (this.getBackofficeGlobalStore.solicitacao.protocoloOperadora) {
      //     params.body.protocoloOperadora = this.getBackofficeGlobalStore.solicitacao.protocoloOperadora
      //   }

      //   if (this.getBackofficeGlobalStore.solicitacao.autorizacaoValidade) {
      //     params.body.autorizacaoValidade = this.getBackofficeGlobalStore.solicitacao.autorizacaoValidade
      //   }

      //   if (this.getBackofficeGlobalStore.solicitacao.autorizacaoObservacao) {
      //     params.body.autorizacaoObservacao = this.getBackofficeGlobalStore.solicitacao.autorizacaoObservacao
      //   }

      //   const response = await this.autorizacao.enviarGuias(params)

      //   if (response.success) {
      //     EventBus.$emit('setSnackbar', { show: true, text: 'Autorização em análise.', icon: 'done', color: '#2E7D32' })
      //     await this.closeModal()
      //   } else {
      //     EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao atualizar a autorização.', icon: 'warning', color: '#C62828' })
      //   }
      // }

      // this.loadingConfirmar = false
      // return false
    }

    if (this.getBackofficeGlobalStore.solicitacao.statusAguardandoOperadora === SituacaoEnum.Cancelada) {
      if (!['', null, undefined].includes(this.getSolicitacaoCancelamentoStore.motivo)) {
        const response = await this.autorizacao.enviarGuias({ acao: SolicitacaoAcoesBackofficeEnum.AutorizacaoAutorizar, body })

        if (response.success) {
          EventBus.$emit('setSnackbar', { show: true, text: 'Solicitação de cancelamento efetuada com sucesso.', icon: 'done', color: '#2E7D32' })
          await this.closeModal()
        } else {
          EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema no cancelamento da solicitação..', icon: 'warning', color: '#C62828' })
        }
      }
    }

    if (this.getPendenciaStore.pendencia.mensagens.length > 0) {
      this.showModalConfirmarPendencia = true
    } else if (this.$refs.autorizacaoForm.$refs.autorizacaoForm.validate()) {
      const response = await this.autorizacao.enviarGuias({ acao: SolicitacaoAcoesBackofficeEnum.AutorizacaoAutorizar, body })

      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Processo atualizado com sucesso!', icon: 'done', color: '#2E7D32' })
        this.getBackofficeAutorizacaoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
        await this.closeModal()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao atualizar a autorização.', icon: 'warning', color: '#C62828' })
      }
    }

    this.loadingConfirmar = false
    return true
  }

  async showHistory() {
    this.loadingHistorico = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getHistoricoSolicitacaoStore.getHistoricoSolicitacao(solicitacaoId)
    this.loadingHistorico = false
  }

  async showComentario() {
    this.loadingComentarios = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.getComentariosStore.getComentariosBySolicitacaoId(solicitacaoId)
    this.getComentariosStore.setShowModalComentario(true)
    this.loadingComentarios = false
  }

  async pendencia() {
    this.loadingPendencia = true
    await timeout(800)
    this.showModalPendencia = true
    this.loadingPendencia = false
  }

  groupByDate(value: any) {
    return groupCollectionByField(value)
  }

  formatHour(value: string) {
    return maskHour(value)
  }

  toggleHtmlOverflow(isOpen: Boolean) {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'

    if (html !== null) {
      html.classList.remove(noOverflowClass)
      if (isOpen) {
        html.classList.toggle(noOverflowClass)
        document.getElementsByClassName('v-dialog')[0].scrollTop = 0
      }
    }
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('scroll-top-autorizada')
    if (ele.length > 0) {
      ele[0].scrollTo(0, 0)
    }
  }

  async closeModalPendencia() {
    this.loadingClosePendencia = true
    await timeoutDefault()
    this.showModalPendencia = false
    this.loadingClosePendencia = false
  }

  async closeModalConfirmarPendencia() {
    this.loadingCloseConfirmarPendencia = true
    await timeoutDefault()
    this.showModalConfirmarPendencia = false
    this.loadingCloseConfirmarPendencia = false
  }

  async confirmarPendencia() {
    this.loadingConfirmarPendencia = true

    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const { mensagens } = this.getPendenciaStore.pendencia
    const response = await this.pendenciaSolicitacao.abrirMensagem(solicitacaoId, mensagens)

    if (response.success) {
      this.getBackofficeAutorizacaoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
      await this.closeModal()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao enviar a pendência.', icon: 'warning', color: '#C62828' })
    }

    this.loadingConfirmarPendencia = false
  }

  async inputFileAgendamento(newFile, oldFile) {
    this.loadingUpload = true
    if (newFile.identifier) {
      return
    }

    const form = new FormData()
    form.append('laudos', newFile.file)
    const time = moment().format('YYYY-MM-DDTHH:mm:ss')

    const param: any = {
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      tipoDocumento: TipoDocumentoUpload.PendenciaHospital,
      formData: form,
    }

    const response = await this.getPendenciaStore.uploadDocumento(param)

    if (response.success) {
      const result = response.data[0]
      const documentoId = result.id
      const { url } = result
      const { nomeArquivo } = result

      const pendenciaMensagem: PendenciaMensagem = {
        mensagemHospital: true,
        id: documentoId,
        dataEnvio: time,
        tipoMensagem: TipoMensagemEnum.Documento,
        texto: '',
        documentoId,
        url,
        nomeArquivo,
      }

      this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    }

    this.loadingUpload = false
  }

  async sendMensagem() {
    this.loadingMensagem = true
    await timeoutDefault()

    const time = moment().format('YYYY-MM-DDTHH:mm')
    const pendenciaMensagem: PendenciaMensagem = {
      mensagemHospital: true,
      id: '',
      dataEnvio: time,
      tipoMensagem: TipoMensagemEnum.Texto,
      texto: this.getMensagem,
    }

    this.getPendenciaStore.setPendenciaMensagem(pendenciaMensagem)
    this.getMensagem = ''
    this.loadingMensagem = false
  }

  clearMensagem() {
    this.getPendenciaStore.clearMensagem()
  }
  /** Fim - Pendência */


  async autorizacaoSolicitaCancelamento() {
    await this.showModalCancelamentoBase()
    this.loadingConfirmar = false
  }

  async showModalCancelamento() {
    this.loadingCancelamento = true
    await this.showModalCancelamentoBase()
    this.loadingCancelamento = false
  }

  async showModalCancelamentoBase() {
    await timeoutDefault()
    const cancelarSolicitacaoParam: CancelarSolicitacaoParam = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      tipoOrigem: TipoOrigemEnum.Agendamento,
      situacao: this.getBackofficeGlobalStore.solicitacao.situacao,
      modal: 'autorizada',
      canceladoMotivo: {
        display: '',
        key: '',
      },
    }

    if (this.getBackofficeGlobalStore.solicitacao.canceladoMotivo) {
      cancelarSolicitacaoParam.canceladoMotivo = this.getBackofficeGlobalStore.solicitacao.canceladoMotivo
    }

    this.getSolicitacaoCancelamentoStore.setCancelarSolicitacaoParam(cancelarSolicitacaoParam)
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoAutorizacao(true)
    await this.getSolicitacaoCancelamentoStore.getMotivosCancelamentoAll({ hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId })
    this.$refs.autorizacaoForm.$refs.autorizacaoForm.resetValidation()
  }

  async closeModalBtn() {
    this.loadingClose = true
    await this.closeModal()
  }

  async closeModal() {
    this.$refs.autorizacaoForm.$refs.autorizacaoForm.reset()
    let solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.autorizacao.desbloquearSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)

    if (this.getSolicitacaoCancelamentoStore.modal.cancelamentoAutorizacao) {
      this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoAutorizacao(false)
    }

    this.getSolicitacaoCancelamentoStore.clear()

    await this.getBackofficeGlobalStore.closeModalAutorizada()
    this.getPendenciaStore.clearPendencia()
    this.loadingClose = false
    await this.getBackofficeAutorizacaoStore.loadAgendamentosMedicoSearch(solicitacaoId)
    solicitacaoId = ''
    this.getPendenciaStore.setModalConfirmar(false)
    this.showModalConfirmarPendencia = false
  }

  windowWidth: number = 0
  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }
}
